import { Card, Stack } from '@mui/material';
import dayjs from 'dayjs';

import { Strings } from '@app/constants';
import { StyledTitle } from '@app/modules/dashboard/style';
import { DataNotFound, Scrollbar } from '@app/components';
import { InfoStatusCard } from '@app/components/card/info-status-card';
import { useRequestState } from '@app/hooks';
import { ITask, selectGetMyProjectLeadersState } from '@app/modules/dashboard';

interface IProps {
  remainingTaskData: ITask[];
}
const InternTasksAndTeamLeadersPage = ({ remainingTaskData }: IProps) => {
  const { data } = useRequestState({
    stateSelector: selectGetMyProjectLeadersState,
  });

  return (
    <Stack flexDirection={{ sm: 'column', md: 'row' }} mb={3}>
      <Card
        sx={{
          width: { sm: '90%', md: '50%' },
          height: '300px',
          margin: '0 2% 0 2%',
          marginTop: { xs: '2%', sm: '2%', md: '0%' },
          borderRadius: '5px',
        }}
      >
        <StyledTitle>{Strings.dashboard.myRemainingTask}</StyledTitle>
        <Scrollbar sx={{ height: 250 }}>
          {remainingTaskData && remainingTaskData?.length > 0 ? (
            remainingTaskData.map((option: ITask) => (
              <InfoStatusCard
                key={option.id}
                titleName={option.name}
                subTitleHead={`${Strings.dashboard.assignedBy}:`}
                subTitleValue={`${option?.user?.firstName} ${option?.user?.lastName}`}
                status={option?.dueDates?.status}
                actionTime={'Due Date:'}
                actionSubValue={
                  option.dueDates?.endDate
                    ? dayjs(option.dueDates?.endDate).format('DD/MM/YYYY')
                    : 'N/A'
                }
              />
            ))
          ) : (
            <Stack sx={{ height: '100%', justifyContent: 'center' }}>
              <DataNotFound height={200} />
            </Stack>
          )}
        </Scrollbar>
      </Card>
      <Card
        sx={{
          width: { sm: '90%', md: '50%' },
          height: '300px',
          margin: { xs: '0 2% 0 2%', sm: '0 2% 0 2%', md: '0 2% 0 0%' },
          marginTop: { xs: '2%', sm: '2%', md: '0%' },
          borderRadius: '5px',
        }}
      >
        <StyledTitle>{Strings.employeeDashborad.myProjectLeaders}</StyledTitle>
        <Scrollbar sx={{ height: 250 }}>
          {data && data?.length > 0 ? (
            data?.map((option: any) => {
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands, @typescript-eslint/restrict-template-expressions
              const managerName = `${option.manager.firstName} ${option.manager.lastName}`;
              return (
                <InfoStatusCard
                  key={option.id}
                  titleName={managerName}
                  subTitleHead={option.name}
                  actionTime={`${Strings.employeeDashborad.projectName}:`}
                  actionSubValue={option.projectName}
                  src={option.manager.profileImage}
                />
              );
            })
          ) : (
            <Stack sx={{ height: '100%', justifyContent: 'center' }}>
              <DataNotFound height={200} />
            </Stack>
          )}
        </Scrollbar>
      </Card>
    </Stack>
  );
};

export { InternTasksAndTeamLeadersPage };
